import React from "react";
import styles from "./labelStatusComponent.module.scss";
import { Box } from "@mui/material";
import i18next from "i18next";
import PropTypes from "prop-types";

const LabelStatusComponent = (props) => {
  const { label } = props;

  
    if (label?.length === 1) {
      return (
        <span className={styles.logLabelText} data-testid="LabelStatusComponent">
          
            <span className={styles.logLabelTextBold}>{i18next.t(label)} </span>{" "}
            {i18next.t('has been updated')}
         
        </span>
      );
    } else if (label?.length === 2) {
      return (
        <Box className={styles.logLabelText} data-testid="LabelStatusComponent">
          
            {label?.map((val, i) => {
              
                if (i !== label?.length - 1) {
                  return (
                    <span key={val} className={styles.logLabelTextBold}>
                      {i18next.t(val)}{" "}
                    </span>
                  );
                } else {
                  return (
                    <span key={val}>
                      {i18next.t(" and ")}
                      <span className={styles.logLabelTextBold}>
                        {i18next.t(val)}{" "}
                      </span>
                    </span>
                  );
                }
              }
            )}{" "}
            {i18next.t('has been updated')}
         
        </Box>
      );
    } else if (label?.length >= 3) {
      return (
        <span className={styles.logLabelText} data-testid="LabelStatusComponent">
          <span className={styles.logLabelTextBold}>
            {i18next.t("Below fields are updated")}
          </span>
        </span>
      );
    }
  }


export default LabelStatusComponent;
LabelStatusComponent.propTypes = {
  label:PropTypes.any
}